export const appLanguages = [
  {
    language: 'English',
    localeCode: 'EN',
  },
  {
    language: 'English (UK)',
    localeCode: 'ENUK',
  },
  {
    language: 'English (AU)',
    localeCode: 'ENAU',
  },
  {
    language: 'Português',
    localeCode: 'PT',
  },
  {
    language: 'Deutsch',
    localeCode: 'DE',
  },
  {
    language: 'Español',
    localeCode: 'ES',
  },
  {
    language: 'French',
    localeCode: 'FR',
  },
];
